var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteCrossSmall = function SvgWhiteCrossSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.142,
    height: 14.142,
    viewBox: "0 0 14.142 14.142",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_851",
    "data-name": "Union 851",
    d: "M3.923,9.133l.153-3.648L.428,5.638A.611.611,0,0,1-.219,4.99a.747.747,0,0,1,.7-.7l3.648-.153L4.286.485a.748.748,0,0,1,.7-.7.611.611,0,0,1,.647.647L5.484,4.077l3.648-.153a.611.611,0,0,1,.647.647.749.749,0,0,1-.7.7l-3.648.153L5.275,9.076a.75.75,0,0,1-.7.7H4.542A.611.611,0,0,1,3.923,9.133Z",
    transform: "translate(13.832 7.071) rotate(135)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteCrossSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteCrossSmall.78824d04.svg";
export { ForwardRef as ReactComponent };